<template>
  <div>
    The lifetime report displays the results regarding the analyzed measures of the space object. 
    The user can find the cumulative orbital changes as well as the propellant consumption. 
    Additionally, the residual metrics linked to potential maneuvers are displayed too. 
    <br />
    <br />
    Please note that these latter metrics are very much related to the inputs of the space object (the ISP of the propulsion system and the initial mass).

    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipLifeTimeReport'
}
</script>
